import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import {
  ComponentsModule,
  PipesModule,
  ImagePlaceholderComponent,
  DataAnalyticsTaggingDirective
} from '@tdwb/core';

// eslint-disable-next-line td-wb-rules/cross-lazyload-module-import-rule
import { LearnDefaultImageModule } from '@tdwb/lazy/learn';

import { LearnDurationModule } from '../duration/learn-duration.module';
import { LearnSavedVideoComponent }  from './learn-saved-video.component';

@NgModule({
  imports: [
    AngularCore,
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule,
    LearnDefaultImageModule,
    LearnDurationModule,
    ImagePlaceholderComponent,
    DataAnalyticsTaggingDirective
  ],
  declarations: [
    LearnSavedVideoComponent
  ],
  exports: [
    LearnSavedVideoComponent
  ]
})
export class LearnSavedVideoModule {
}
